import { useEffect, useState } from 'react';

// Tracks whether the current viewport is too narrow for the calculator
// shell (multi-column table model). Threshold = 768 px (Tailwind's
// `md` breakpoint) — below this the new MeasureTable + Results split
// has nowhere to go, so CalculatorApp swaps in <MobileSplash /> and
// nudges the user to open on desktop. See mobile-policy memo.
//
// Listens to window resize so the splash appears/disappears live; on
// SSR the initial value is `false` (assume full-size; React hydrates
// to the correct value on first client render).

const MIN_WIDTH = 768;

export function useTooNarrowForCalculator() {
  const [narrow, setNarrow] = useState(() =>
    typeof window === 'undefined' ? false : window.innerWidth < MIN_WIDTH
  );
  useEffect(() => {
    const onResize = () => setNarrow(window.innerWidth < MIN_WIDTH);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return narrow;
}
